module.exports = __webpack_public_path__ + "static/media/Spring_Boot.edf462fe.svg";